query getScheduledContents($input: GetScheduledContentsInput!) {
  scheduledContents: getScheduledContents(input: $input) {
    page
    perPage
    total
    scheduledContents {
      id
      text
      imagePath
      imageSource
      carouselImages
      textKind
      scheduledAt
      url
      topicId
      postingBatchId
      totalOffices
      totalRecipients
      recipientSegment
      topicName
      targetLink
      publication
      invitations {
        name
        recipientCount
        targetLink
        failedCount
        failedDeliveryError
      }

      platformTexts {
        INSTAGRAM
        LINKEDIN
      }
      officeCount
      accountCount
      socialMediaPosts {
        type
        postId
        scheduledAt
        completedAt
        hasFailed
        failureReason
        id
      }
    }
  }
}
